export default __webpack_public_path__ + "static/media/Why-SSN.8a02d789.vtt";